<template>
  <div class="sharkbet-account-menu" :class="`sharkbet-account-menu--${variant}`">
    <button type="button" data-bs-toggle="modal" data-bs-target="#sharkbetMyAccount" @click="dismiss">
      <i class="fas fa-user-circle"></i>
      <span>Mi cuenta</span>
    </button>
    <button v-if="variant === 'mobile' && isJmAccount && userMenu.balanceHistory" type="button" data-bs-toggle="modal"
      data-bs-target="#myAccountJm" @click="getMovements">
      <i class="fas fa-wallet"></i>
      <span>Historial de Juego</span>
    </button>
    <button v-if="variant === 'mobile' && skin.my_account?.movements" type="button" data-bs-toggle="modal"
      data-bs-target="#sharkbetTransactions" @click="dismiss">
      <i class="fas fa-list"></i>
      <span>Transacciones</span>
    </button>
    <button v-if="variant === 'mobile'" type="button" data-bs-toggle="modal" data-bs-target="#sharkbetBonuses" @click="dismiss">
      <i class="fas fa-money-bill-wave"></i>
      <span>Mis Bonificaciones</span>
    </button>
    <button v-if="variant === 'mobile' && isJmAccount && userMenu.changePassword" id="changePasswordBtn" type="button"
      data-bs-toggle="modal" data-bs-target="#changePasswordJm" @click="dismiss">
      <i class="fas fa-key"></i>
      <span>{{ translate('change_password') }}</span>
    </button>
    <button v-if="variant === 'mobile' && isJmAccount && userMenu.loginHistory" type="button" data-bs-toggle="modal"
      data-bs-target="#historial_ingresos" @click="getIngresos">
      <i class="fas fa-clock-rotate-left"></i>
      <span>{{ translate('history_ingre') }}</span>
    </button>
    <button v-if="variant === 'mobile' && userMenu.sportsRules" type="button" @click="terms">
      <i class="fas fa-file-contract"></i>
      <span>{{ translate('regulations') }}</span>
    </button>
    <button v-if="skin.logout" type="button" class="sharkbet-account-menu__logout" @click="logout">
      <i class="fas fa-sign-out-alt"></i>
      <span>{{ translate('go_out') }}</span>
    </button>

  </div>
</template>

<script>
export default {
  name: 'SharkbetAccountMenu',
  props: {
    skin: { type: Object, required: true },
    language: { type: String, required: true },
    translation: { type: Object, required: true },
    variant: { type: String, default: 'desktop' },
  },
  computed: {
    userMenu() {
      return (this.variant === 'mobile' ? this.skin.header_mobil?.userMenu : this.skin.header_desktop?.userMenu) || this.skin.header_desktop?.userMenu || {};
    },
    isJmAccount() {
      return this.skin.my_account?.myaccount_type === 'JM';
    },
    user() {
      return this.$store.getters['getUserData'];
    },
  },
  methods: {
    dismiss() {
      this.$emit('dismiss');
    },
    getMovements() {
      this.$root.$emit('getMovementsHistory');
      this.dismiss();
    },
    getIngresos() {
      this.$root.$emit('getIngresosHistory');
      this.dismiss();
    },
    terms() {
      const lang = this.language === 'es' ? 'spa' : this.language === 'en' ? 'eng' : this.language === 'pt' ? 'pt-br' : 'spa';
      let url = '';

      if (this.user.prefix === 'external') {
        url = `https://docs.betsw3.xyz/terms/${lang}/?site=${this.user.site.toUpperCase()}&link=${this.user.site}`;
      } else {
        const domainParts = this.user.domain.split('//')[1].split('.');
        url = `https://docs.betsw3.xyz/terms/${lang}/?site=${domainParts[1].toUpperCase()}&link=${domainParts[1]}.${domainParts[2]}`;
      }

      window.open(url, '_blank');
      this.dismiss();
    },
    logout() {
      this.$emit('logout');
      this.dismiss();
    },
    translate(text) {
      if (this.translation[text]) return this.translation[text][this.language];
      const normalized = text.replace(/ /g, '_');
      return this.translation[normalized]?.[this.language] || text;
    },
  },
};
</script>

<style scoped>
.sharkbet-account-menu {
  display: grid;
  gap: 2px;
}

.sharkbet-account-menu > button {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: #fff;
  cursor: pointer;
  display: flex;
  font: 500 16px 'Roboto', sans-serif;
  gap: 9px;
  padding: 9px 12px;
  text-align: left;
}

.sharkbet-account-menu > button:hover {
  background: rgba(0, 146, 205, .16);
  color: #00b6ff;
}

.sharkbet-account-menu > button i {
  color: #0092cd;
  width: 14px;
}

.sharkbet-account-menu:not(.sharkbet-account-menu--mobile) > button {
  padding-left: 8px;
}

.sharkbet-account-menu:not(.sharkbet-account-menu--mobile) > button i {
  display: none;
}

.sharkbet-account-menu:not(.sharkbet-account-menu--mobile) > button:hover {
  background: transparent;
  color: #fff;
}

.sharkbet-account-menu__logout {
  border-top: 1px solid rgba(255, 255, 255, .12) !important;
  margin-top: 4px;
  padding-top: 12px !important;
}

.sharkbet-account-menu__logout i {
  color: #ff6b7a !important;
}

.sharkbet-account-menu--mobile > button {
  background: #ececec;
  border-bottom: 1px solid #fff;
  border-radius: 0;
  color: #1d252c;
  font: 700 16px 'Roboto Condensed', 'Roboto', sans-serif;
  min-height: 50px;
  padding: 10px 26px;
}

.sharkbet-account-menu--mobile > button i,
.sharkbet-account-menu--mobile > button.sharkbet-account-menu__logout i {
  color: #1d252c !important;
}

.sharkbet-account-menu--mobile > button:hover {
  background: #e2e2e2;
  color: #0092cd;
}

.sharkbet-account-menu--mobile > button.sharkbet-account-menu__logout {
  border-top: 0 !important;
  margin-top: 0;
  padding-top: 10px !important;
}
</style>
